<hip-modal [routeToGoOnBackdropClick]="'/auth'">
  <hip-terms-and-conditions [mustSelectOption]="true"></hip-terms-and-conditions>
</hip-modal>
